module.exports = __webpack_public_path__ + "2ff029e37c306bc23b63f1a2d48cab78.svg";